import * as React from 'react';
const AnchorLinkContext = React.createContext(false);
function AnchorLinkProvider({ children }) {
    return React.createElement(AnchorLinkContext.Provider, { value: true }, children);
}
function useIsWithinAnchorLink() {
    return React.useContext(AnchorLinkContext);
}
export { AnchorLinkProvider, useIsWithinAnchorLink };
//# sourceMappingURL=AnchorLinkContext.js.map